import script from "./FileHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileHistory.vue?vue&type=script&setup=true&lang=ts"

import "./FileHistory.vue?vue&type=style&index=0&id=d8776416&scoped=true&lang=css"

import exportComponent from "/builds/SalesIT/ijaa/import-tool/ls-import-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8776416"]])

export default __exports__